<template>
  <div>
    <a-card size="small" title="查询" :headStyle="{
        background: '#f3f3f3',
      }">
      <a-form layout="inline">

        <a-form-item>
          <df-selectChannelShop
              @setValue="searchAction()"
              :model="searchForm"
          ></df-selectChannelShop>
        </a-form-item>


        <a-form-item>
          <a-input
            v-model:value="searchForm.code"
            allowClear
            @keyup.enter.native="searchAction()"
            :placeholder="'请输入' + codeType"
          >
            <template v-slot:addonBefore>
              <a-select v-model:value="codeType" style="width: 100px">
                <a-select-option value="订单编号">订单编号</a-select-option>
                <a-select-option value="退票单号">退票单号</a-select-option>
                <a-select-option value="顾客姓名">顾客姓名</a-select-option>
              </a-select>
            </template>
          </a-input>
        </a-form-item>

        <a-form-item>
          <a-range-picker
            v-model:value="searchForm.date"
            :placeholder="['出票开始', '出票结束']"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction">查询</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="refundOrdersDownload">下载</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item></a-form-item>
      </a-form>
    </a-card>

    <a-card
      size="small"
      title
      :defaultActiveTabKey="activeKey"
      style="margin-top: 20px"
      @tabChange="cardtabChange"
      class="log_content"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
      :tabList="panes"
    >
      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 1300 }"
        :row-key="(r) => r.id"
        :loading="loading"
      >
        <template v-slot:orderCode="{ text, record }">
          <div
            style="color: #464c5b; cursor: pointer"
            @click="toDetail(record)"
          >{{ record.orderCode }}</div>
        </template>
        <template v-slot:train="{ text, record }">
          <div v-if="record.trainInfoVal">
            <div>
              {{ record.trainInfoVal.fromStation }} ->
              {{ record.trainInfoVal.toStation
              }}
              <span style="color: red; margin-left: 10px">({{ record.trainInfoVal.trainNo }})</span>
            </div>
            <div>
              {{ record.trainInfoVal.date }}&nbsp;&nbsp;{{
              record.trainInfoVal.fromTime
              }}&nbsp;&nbsp; - &nbsp;&nbsp;{{
              record.trainInfoVal.date
              }}&nbsp;&nbsp;{{ record.trainInfoVal.toTime }}
            </div>
          </div>
        </template>

        <template v-slot:passengersList="{ text, record }">
          <a-table
            :columns="columnsInner"
            bordered
            :data-source="record.passengerInfoVal"
            :pagination="false"
            :showHeader="false"
            :row-key="(r) => r.price"
          ></a-table>
        </template>

        <template v-slot:money="{ text, record }">
          <span style="color: red">¥{{ record.refundAmount }}</span>
        </template>

        <!-- <template v-slot:orderState="{ text,record }">
          {{record.orderStateMsg}}
        </template>-->

        <template v-slot:operation="{ text, record }">
          <a-button type="primary" @click="toDetail(record)">查看订单</a-button>
          <!-- <a-button type="danger" style='margin-left:5px' @click="cancel(record)" v-if='record.orderState == 30 || record.orderState == 60'>
            取消订单
          </a-button>-->
        </template>
      </a-table>
    </a-card>

    <df-pagination :model="pageObj"></df-pagination>
    <a-modal v-model="modalVisible" title="暂停自动出票">
      <!-- @ok="handleOk" -->
      <a-form
        layout="horizontal"
        ref="submitForm"
        :model="submitForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="暂停渠道" prop="companyName">
          <a-input v-model="submitForm.companyName" placeholder="企业名称" style="width: 282px" />
        </a-form-item>

        <a-form-item label="结束时间" prop="companyName">
          <a-date-picker
            format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import orderApi from "@axios/order";
import moment from "moment";
import { reactive, ref, provide } from "vue";
import orderState from "@assets/static";
import { useRouter } from "vue-router";
import { message,Modal, destroyAll, notification } from "ant-design-vue";
import excelApi from "@axios/downloadExcel";
import tools from "@/utils/tools";

export default {
  name: "shop",
  components: {},
  setup() {
    const router = useRouter();
    const columnsInner = [
      {
        title: "票号",
        dataIndex: "ticketNo",
        width: 100,
        align: "center",
      },
      {
        title: "购票人",
        dataIndex: "name",
        width: 100,
        align: "center",
      },
      {
        title: "座位",
        dataIndex: "seat",
        width: 100,
        align: "center",
      },
    ];
    let panes = ref([
      { tab: "全部", key: "0" },
      { tab: "退票中", key: "20" },
      { tab: "部分退票", key: "30" },
      { tab: "退票完成", key: "40" },
      { tab: "退票失败", key: "90" },
    ]);

    let modalVisible = ref(false);
    let visible = ref(false);
    let loading = ref(false);
    let submitForm = reactive({});
    let searchForm = reactive({
      code: "",
      date: [],
      distributorId:undefined
    });
    let searchParams = reactive({
      code: "",
      date: [],
    });
    let list = ref([]);

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    let activeKey = ref("0");

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    const cardtabChange = (key) => {
      activeKey.value = key;
      reset();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    const searchAction = () => {
      searchParams.code = searchForm.code;
      searchParams.date = searchForm.date;
      searchParams.distributorId = searchForm.distributorId;

      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    const refundOrdersDownload = () => {
      searchParams.code = searchForm.code;
      searchParams.date = searchForm.date;

      let params = {
        state: activeKey.value == "0" ? null : activeKey.value,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
        distributorId : searchParams.distributorId
      };

      if (searchParams.date.length) {
        params.finishBeginTime = searchParams.date[0];
        params.finishEndTime = searchParams.date[1];
      }

      if (searchParams.code) {
        if (codeType.value == "订单编号") {
          params.orderCode = searchParams.code;
        } else if (codeType.value == "顾客姓名") {
          params.passengerName = searchParams.code;
        } else if (codeType.value == "退票单号") {
          params.returnOrderCode = searchParams.code;
        }
      }

      params.returnState = 30

      if (params.finishBeginTime === undefined || params.finishBeginTime === '' || params.finishEndTime === undefined || params.finishEndTime === ''){
        message.error("请选择时间区间！");
        return
      }

      if (!tools.isWithinLastThreeMonths(params.finishBeginTime,params.finishEndTime)){
        message.error("下载时间区间，不能大于三个月！");
        return
      }

      excelApi.ordersExcel(params).then((res) => {
        let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"}); // 为blob设置文件类型，这里以.xlsx为例
        let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
        let a = document.createElement("a");
        a.href = url;
        a.download = '退票订单报表'+tools.getNowDate();
        a.click();
        // 释放这个临时的对象url
        window.URL.revokeObjectURL(url);
        //getList();
      }).catch((err) => {});

    };





    const getList = async () => {
      loading.value = true;
      let params = {
        state: activeKey.value == "0" ? null : activeKey.value,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
        distributorId : searchParams.distributorId
      };

      params.distributorId = searchParams.distributorId

      if (searchParams.date.length) {
        params.finishBeginTime = searchParams.date[0];
        params.finishEndTime = searchParams.date[1];
      }

      if (searchParams.code) {
        if (codeType.value == "订单编号") {
          params.orderCode = searchParams.code;
        } else if (codeType.value == "顾客姓名") {
          params.passengerName = searchParams.code;
        } else if (codeType.value == "退票单号") {
          params.returnOrderCode = searchParams.code;
        }
      }

      await orderApi.getRefundList(params).then((res) => {
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        list.value = res.data;
      });
      getCount(params);
    };

    const getCount = (params) => {
      if (params.orderState) delete params.orderState;
      orderApi.refundCount(params).then((res) => {
        panes.value = [
          { tab: "全部", key: "0" },

          { tab: "退票中", key: "20" },
          { tab: "部分退票", key: "30" },
          { tab: "退票完成", key: "40" },
          { tab: "退票失败", key: "90" },
        ];

        let sum = 0;

        let contObj = {};

        res.bodies.forEach((element) => {
          if (element.code) {
            contObj[element.code] = element.num;
          } else {
            sum = element.num;
          }
        });

        panes.value.forEach((element) => {
          if (element.key != "0" && contObj[element.key]) {
            element.tab = element.tab + " ( " + contObj[element.key] + " ) ";
          } else if (element.key == "0" && sum) {
            element.tab = element.tab + " ( " + sum + " ) ";
          }
        });
      });
    };

    const reset = () => {
      searchForm.code = "";
      searchForm.date = [];
      searchForm.orderdate = [];
      searchForm.from = "";
      searchForm.to = "";
      searchAction();
    };

    const toDetail = (row) => {
      router.push({
        name: "refundDetailIndex",
        query: {
          code: row.returnOrderCode,
        },
      });
    };

    const cancel = (row) => {
      Modal.confirm({
        content: "是否确定取消该订单？",
        onOk() {
          let params = {
            orderCode: row.orderCode,
          };
          orderApi.orderConcel(params).then((res) => {
            notification.open({
              message: "取消成功",
              icon: <SmileOutlined style="color: #108ee9" />,
            });
            getList();
          });
        },
        cancelText: "取消",
        okText: "确定",
        onCancel() {
          Modal.destroyAll();
        },
      });
    };

    let codeType = ref("订单编号");

    getList();
    return {
      codeType,
      cancel,
      panes,
      reset,
      refundOrdersDownload,
      searchAction,
      activeKey: activeKey,
      modalVisible,
      visible,
      loading,
      submitForm,
      list,
      rules: {
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      stateList: [
        {
          name: "供应",
          val: 10,
        },
        {
          name: "渠道",
          val: 20,
        },
      ],
      columns: [
        {
          title: "订单编号",
          dataIndex: "orderCode",
          width: 200,
          align: "center",

          slots: { customRender: "orderCode" },
        },
        {
          title: "退票编号",
          dataIndex: "returnOrderCode",
          width: 200,
          align: "center",

          slots: { customRender: "returnOrderCode" },
        },
        {
          title: "车次信息",
          dataIndex: "mobile",
          width: 300,
          align: "left",
          slots: { customRender: "train" },
        },
        {
          title: "票号/购票人/座位",
          dataIndex: "taxpayerNum",
          width: 400,
          align: "center",
          slots: { customRender: "passengersList" },
        },
        {
          title: "退款金额",
          dataIndex: "stateName",
          width: 100,
          align: "center",
          slots: { customRender: "money" },
        },
        {
          title: "提交时间",
          dataIndex: "createTime",
          width: 150,
          align: "center",
        },
        {
          title: "订单状态",
          dataIndex: "stateVal",
          width: 150,
          align: "center",
          // slots: { customRender: 'orderState' },
        },
        // {
        //   title: '操作',
        //   align : 'center',
        //   dataIndex: 'operation',
        //   key: 'operation',
        //   width: 220,

        //   slots: { customRender: 'operation' },
        // },
      ],
      searchForm,
      searchParams,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      moment,
      pageObj,
      disabledDate(current) {
        // Can not select days before today and today

        return current && current < moment().endOf("day");
      },
      cardtabChange,
      columnsInner,
      orderState,
      toDetail,
    };
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.log_content /deep/ .ant-card-extra {
  float: none;
  margin-left: 0;
}
</style>

